/*
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-11-18 17:37:43
 * @LastEditors: guanbowen 
 * @LastEditTime: 2023-06-20 13:25:45
 */
import Layout from '@main/components/layout/layoutView.vue'
import Vue from 'vue'
import VueRouter from 'vue-router'
import { parentRoutes, subRoutes } from '../config/autoRouters'

Vue.use(VueRouter)
const routers = [
  {
    path: '/',
    component: Layout,
    hidden: true,
    redirect: '/home',
    // redirect: '/contractManage',
    children: [...subRoutes]
  },
  // { path: '/user/profile', component: UserProfile, hidden: true },
  ...parentRoutes
]
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error)
}
const router = new VueRouter({
  mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({
    y: 0
  }),
  routes: routers
})

export default router
